import request, { IWorkspaceResponse } from './http/Xrequest '

interface IAlgPageQueryParams {
  pageNum?: number;
  pageSize?: number;
}

// 分页查询算法列表
export const getAlgPage = async function (params: IAlgPageQueryParams): Promise<IWorkspaceResponse<any>> {
  const url = '/business/algorithm/list'
  const result = await request.get(url, { params })
  return result.data
}

// 查询algorithm所有列表
export const getAllAlgList = async function (params: any): Promise<IWorkspaceResponse<any>> {
  const url = '/business/algorithm/listAll'
  const result = await request.get(url, { params })
  return result.data
}

// 算法详情
export const getAlgQualification = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `/business/algorithm/getInfo/${id}`
  const result = await request.get(url)
  return result.data
}
